import React, { useEffect } from "react";
import { UseFormReturn, useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { ReactComponent as RemoveSVG } from "go-core/images/svg/actions/remove.svg";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { adminApi } from "../../../../../../../../../services/Api/Admin/adminApi";
import { GoLauncherApplicationApi } from "../../../../../../../../../services/Api/Admin/adminTypes";

interface Props {
	form: UseFormReturn<GoLauncherApplicationApi>;
}

const GoLauncherApplicationCustomFeaturesForm = ({ form }: Props) => {
	const {
		watch,
		control,
		formState: { errors },
		register,
	} = form;
	const { t } = useTranslation("admin");
	const watchedItems = watch("custom_features");
	const { fields, remove, append } = useFieldArray({
		control,
		name: "custom_features",
		keyName: "key",
	});
	const watchedItemsAsString = JSON.stringify(watchedItems);

	useEffect(() => {
		if (checkIfAddNewItem()) {
			append(
				{
					parameter: "",
					type: "",
					title: "",
				},
				{
					shouldFocus: false,
				}
			);
		}
	}, [watchedItemsAsString]);

	const checkIfAddNewItem = () => {
		const previousItem = watchedItems[watchedItems.length - 1];
		return previousItem.title || previousItem.type || previousItem.parameter;
	};

	const searchType = async (search: string, _: Record<string, any>, options?: Record<string, any>) => {
		const res = await adminApi.getGoLauncherApplicationCustomFeatures(search, options);
		return res.map((item) => ({
			value: item,
			label: item,
		}));
	};

	return (
		<>
			<h5>{t("modules.go_launcher.field.custom_features.title")}</h5>
			<fieldset className="form-group">
				<table className="table table-form">
					<thead>
						<tr>
							<th className="action" />
							<th className="w-40">{t("lib:common.word.type")}</th>
							<th className="w-30">{t("modules.go_launcher.field.title.title")}</th>
							<th className="w-30">{t("modules.go_launcher.field.parameter.title")}</th>
							<th className="action" />
						</tr>
					</thead>
					<tbody>
						{watchedItems.map((item, index) => (
							<tr key={fields[index].key}>
								<td className="action" />
								<td>
									<FormSelectGroup
										errors={errors}
										control={control}
										name={`custom_features.${index}.type`}
										loadOptions={searchType}
										data-testid={`custom_features.${index}.type`}
										defaultValue={{
											label: item.type,
											value: item.type,
										}}
									/>
								</td>
								<td>
									<FormInput
										name={`custom_features.${index}.title`}
										errors={errors}
										register={register}
									/>
								</td>
								<td>
									<FormInput
										name={`custom_features.${index}.parameter`}
										errors={errors}
										register={register}
									/>
								</td>
								<td className="action">
									{!(
										(watchedItems.length === 1 && index === 0) ||
										index === watchedItems.length - 1
									) && <RemoveSVG className="icon" onClick={() => remove(index)} />}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</fieldset>
		</>
	);
};

export default GoLauncherApplicationCustomFeaturesForm;
